import { memo } from 'react'

import { Text } from 'common-components'

import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { useSelector } from 'react-redux'

const ActiveTrackName: React.FC = () => {
  const selectedSoundName = useSelector(projectDataSelectors.activeAudioTitle)

  return (
    <Styled.ActiveTrackNameWrapper>
      <Text type="h6" color="secondary">
        {translate(T.TRACK)}:
      </Text>
      <Text type="h6" fontWeight="500" color="secondary">
        {selectedSoundName}
      </Text>
    </Styled.ActiveTrackNameWrapper>
  )
}

export default memo(ActiveTrackName)
